export const module12InitialState = {
  module12: {
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    coins: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      SlideRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SlideYellow: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      GnomeBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      GnomeGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SpringToy: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      TireSwing: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FairyGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FairyPurple: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      MonkeybarsBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      MonkeybarsYellow: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FrogCrown: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FrogVelvet: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      KitePink: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      KitePurple: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FlowerPink: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FlowerBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FaeDragon: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FaeHouse: {
        unlocked: false,
        x: 0,
        y: 0,
      },
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
    },
  },
};

export const Module12Reducer = (state = module12InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE12_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        SlideRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SlideYellow: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        GnomeBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        GnomeGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SpringToy: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        TireSwing: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FairyGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FairyPurple: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        MonkeybarsBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        MonkeybarsYellow: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FrogCrown: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FrogVelvet: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        KitePink: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        KitePurple: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FlowerPink: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FlowerBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FaeDragon: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FaeHouse: {
          unlocked: false,
          x: 0,
          y: 0,
        },
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]].unlocked = true;
              tempRewards[Object.keys(tempRewards)[j]].x = obj[i]?.x_multiplier;
              tempRewards[Object.keys(tempRewards)[j]].y = obj[i]?.y_multiplier;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[], "tokens_earned":0}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"SlideRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SpringToy\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"FairyGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"FlowerBlue\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module12: {
          ...state.module12,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
          coins: JSON.parse(tempObj)?.tokens_earned,
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module12InitialState,
      };
    }
    case 'MODULE12_SET_DAY': {
      return {
        ...state,
        module12: {
          ...state.module12,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE12_SET_GameDetials': {
      return {
        ...state,
        module12: {
          ...state.module12,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE12_SET_stepCompleted': {
      return {
        ...state,
        module12: {
          ...state.module12,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE12_SET_dayCompleted': {
      return {
        ...state,
        module12: {
          ...state.module12,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE12_SET_CAMERAOPEN': {
      return {
        ...state,
        module12: {
          ...state.module12,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE12_SET_KEY': {
      return {
        ...state,
        module12: {
          ...state.module12,
          keys: action.payload,
        },
      };
    }
    case 'MODULE12_SET_COIN': {
      return {
        ...state,
        module12: {
          ...state.module12,
          coins: action.payload,
        },
      };
    }
    case 'MODULE12_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module12: {
          ...state.module12,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE12_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module12: {
          ...state.module12,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE12_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module12: {
          ...state.module12,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE12_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module12: {
          ...state.module12,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE12_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module12: {
          ...state.module12,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE12_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module12: {
          ...state.module12,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE12_SET_REWARD11': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            SlideRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD11_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            SlideRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD12': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            SlideYellow: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD12_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            SlideYellow: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD21': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            GnomeBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD21_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            GnomeBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD22': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            GnomeGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD22_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            GnomeGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD31': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            SpringToy: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD31_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            SpringToy: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD32': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            TireSwing: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD32_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            TireSwing: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD41': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FairyGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD41_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FairyGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD42': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FairyPurple: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD42_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FairyPurple: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD51': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            MonkeybarsBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD51_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            MonkeybarsBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD52': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            MonkeybarsYellow: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD52_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            MonkeybarsYellow: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD61': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FrogCrown: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD61_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FrogCrown: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD62': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FrogVelvet: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD62_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FrogVelvet: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD71': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            KitePink: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD71_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            KitePink: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD72': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            KitePurple: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD72_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            KitePurple: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD81': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FlowerPink: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD81_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FlowerPink: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD82': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FlowerBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_REWARD82_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FlowerBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_PRIZE1': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FaeDragon: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_PRIZE1_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FaeDragon: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_PRIZE2': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FaeHouse: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_PRIZE2_POSITION': {
      return {
        ...state,
        module12: {
          ...state.module12,
          rewards: {
            ...state.module12.rewards,
            FaeHouse: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE12_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module12: {
          ...state.module12,
          unlockedDays: {
            ...state.module12.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE12_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module12: {
          ...state.module12,
          unlockedDays: {
            ...state.module12.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE12_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module12: {
          ...state.module12,
          unlockedDays: {
            ...state.module12.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE12_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module12: {
          ...state.module12,
          unlockedDays: {
            ...state.module12.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE12_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module12: {
          ...state.module12,
          unlockedDays: {
            ...state.module12.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE12_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module12: {
          ...state.module12,
          unlockedDays: {
            ...state.module12.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE12_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module12: {
          ...state.module12,
          unlockedDays: {
            ...state.module12.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE12_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module12: {
          ...state.module12,
          unlockedDays: {
            ...state.module12.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }

    default:
      return state;
  }
};
export default Module12Reducer;
